import { render, staticRenderFns } from "./batch-approval.vue?vue&type=template&id=1f9b3410&"
import script from "./batch-approval.vue?vue&type=script&lang=js&"
export * from "./batch-approval.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports